// extracted by mini-css-extract-plugin
export var divider = "_28-0";
export var dividerText = "_28-1";